import React from "react";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Toast = {
  success: (message: string) => toast.success(message),
  error: (message: string) => toast.error(message),
  info: (message: string) => toast.info(message),
  warning: (message: string) => toast.warning(message),
};

export const ToastProvider = () => <ToastContainer  position="top-right" autoClose={3000} hideProgressBar={false} closeOnClick pauseOnFocusLoss draggable pauseOnHover />;

export const generatetoast = (type: string, message: string) => {
    switch (type) {
      case "success":
        return Toast.success(message);
      case "error":
        return Toast.error(message);
      case "warning":
        return Toast.warning(message);
      case "info":
        return Toast.info(message);
      default:
        return Toast.success(message)
    }
  };